import { useQuery } from "@tanstack/react-query";
import { useLoginStore } from "features/login/store";
import { apiUsuarioRotaMinhas } from "../api/apiUsuarioRotaMinhas";

/** Usuário logado segundo o backend (fonte da verdade para "é admin?"). */
export function useMinhasRotas() {
	const token = useLoginStore((s) => s.login?.token);

	return useQuery({
		queryKey: ["apiUsuarioRotaMinhas", token],
		queryFn: apiUsuarioRotaMinhas,
		enabled: !!token,
		staleTime: 5 * 60 * 1000,
		retry: false,
	});
}
